import form from './form';
import table from './table';

export default {
  layout: 'attestation-layout',
  grid: 'attestation-grid',
  form,
  table,
};
